<template>
  <div class="login-section">

    <div class="login-logo-section">
      <div class="login-logo">
        <img src="@/assets/img/logo.png">
      </div>
    </div>

    <div class="login-form">
      <form @submit.prevent="submit">

        <div class="login-title">
          LOGIN
        </div>

        <div class="custom-input-section">
          <div>
            <v-text-field outlined dense class='custom-input' label="Email" :rules="rules" v-model="form.email"></v-text-field>
          </div>
          <div>
            <v-text-field outlined dense class='custom-input' label="Password" type='password' :rules="rules" v-model="form.password"></v-text-field>
          </div>
          <div class="submit">
            <v-btn
              depressed
              color="primary"
              type="submit"
              class="custom-btn"
            >
              Log in
            </v-btn>
          </div>
        </div>

      </form>
    </div>

  </div>
</template>

<script>
  import api from '@/api'
  import axios from 'axios'
  import messageMixin from '@/mixin/messageMixin'
  import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  mixins: [messageMixin],
  components: {

  },

  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      rules: [
        value => !!value || 'Required.',
        value => (value && value.length >= 3) || 'Min 3 characters',
      ],
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    })
  },

  methods: {

    submit () {
      this.logIn(this.form)
    },

    async logIn (credentials) {

      const response = await api.auth.login(credentials)
      if (response.status < 300) {
        localStorage.logged = response.data.logged
      } else {
        console.log('response BAD', response)
      }

      if (response.error) {
        this.displayError(response.error)
        return
      }
      //redirect
      setTimeout(function() {
        window.location.href = '/'
      }, 500)
    },

    async catchVerificationCode () {
      const verificationCode = this.$route.query.verificationCode
      if(!verificationCode) {
        return
      }

      let response = await axios.post('auth/verification', {verificationCode:verificationCode}).then(response => {
        return response.data
      })
      .catch(error => {
        return { error: error.response.data.errors }
      })

      if (response.error) {
        this.displayError(response.error)
        return
      }

      if(response.success) {
        this.displaySuccess(response.message)
      }

    }
  },

  watch: {
    user() {
      if(this.user.role == 'user') {
        this.$router.push({
          name: 'Home'
        })
      }

      if(this.user.role == 'owner') {
        this.$router.push({
          name: 'Dashboard'
        })
      }
    }
  },

  mounted () {
    this.catchVerificationCode()
  }
}
</script>

<style lang="scss" scoped="scoped">

  .login-section {

    .login-logo-section {
      width: 400px;
      margin: auto;
      margin-top: 60px;
      margin-bottom: -15px;

      .login-logo {
        width: 100%;

        img {
          width: 100%;
        }
      }
    }

    .login-form {
      width: 500px;
      margin: auto;
      margin-top: 90px;
      border: 1px solid #e2e8ef;
      border-radius: 3px;
      box-shadow: 0 2px 0 #f3f3f3!important;
      background: #fff;

      .login-title {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-weight: 600;
        border-bottom: 1px solid #e2e8ef;
        border-radius: 3px;
        color: #1976d2;
      }

      .custom-input-section {
        margin-top: 30px;
        padding-left: 45px;
        padding-right: 45px;

        .custom-input {

        }
      }

      .custom-btn {
        width: 100%;
        height: 50px;
        margin-top: 0px;
        margin-bottom: 25px;
      }
    }
  }

  .v-application {

    .primary--text {

    }

  }

</style>
